import React from 'react';
import { Form } from 'react-bootstrap';
import { ErrorMessage } from 'formik';

export default props => <ErrorMessage component={Form.Control.Feedback} {...props} />;

